import { ADMIN_ROLE, PSYCHOLOGIST_ROLE } from '@/configs';
import { FETCH_PROFILE, LOGOUT_PROFILE } from './authActionsTypes';

const INIT_STATE = {
  isLoaded: false,
  isAuth: false,
};

const authReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PROFILE}_FULFILLED`:
      return {
        ...state,
        ...payload,
        user_role: payload?.is_superuser ? ADMIN_ROLE : PSYCHOLOGIST_ROLE,
        isLoaded: true,
        isAuth: true,
      };
    case `${FETCH_PROFILE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
      };
    case LOGOUT_PROFILE:
    default:
      return state;
  }
};

export default authReducer;
